export enum AuthRoles {
  SUPER_ADMIN = 'Super Admin',
  USER = 'User',
  LOCATION_ADMIN = 'Location Admin',
  ORG_ADMIN = 'Org Admin',
}

export enum EquipmentStatus {
  ONLINE = 'Online',
  OFFLINE = 'Offline',
  TROUBLE = 'Trouble',
  NONE = 'None',
}

export enum EquipmentBrands {
  CISCO = 'Cisco',
  CRADLEPOINT = 'Cradlepoint',
  CYBERPOWER = 'CyberPower',
  DATAREMOTE = 'DataRemote',
  ERICSSON = 'Ericsson',
  GRANDSTREAM = 'Grandstream',
  INHAND = 'Inhand',
  LYD = 'LYD',
  MOFI = 'MOFI',
  NAPCO = 'NAPCO',
  PATTON = 'Patton',
  PEPWAVE = 'Pepwave',
  POWERTEC = 'Powertec',
  SANGOMA = 'Sangoma',
  TALENTCELL = 'Talentcell',
  YABO = 'YABO',
}

export enum LocationStatus {
  PROVISIONING = 'Provisioning',
  SHIPPING = 'Shipping',
  OPERATIONAL = 'Operational',
  NEEDS_SERVICE = 'Needs Service',
  NOT_OPERATIONAL = 'Not Operational',
  SUSPENDED = 'Suspended',
  DECOMMISSIONED = 'Decommissioned',
}

export enum FieldRequired {
  REQUIRED = 'Required',
  OPTIONAL = 'Optional',
  NOT_APPLICABLE = 'Not Applicable',
}

export enum ActiveUplink {
  ETHERNET = 'Ethernet',
  CELLULAR = 'Cellular',
}

export enum WebhookEventType {
  ROUTER_STATUS_CHANGED = 'ROUTER_STATUS_CHANGED',
  POWERSOURCE_STATUS_CHANGED = 'POWERSOURCE_STATUS_CHANGED',
  LOCATION_STATUS_CHANGED = 'LOCATION_STATUS_CHANGED',
  SIGNAL_STATUS_CHANGED = 'SIGNAL_STATUS_CHANGED',
  INVENTORY_CHANGED = 'INVENTORY_CHANGED',
  ROUTER_ACTIVE_ROUTE_CHANGED = 'ROUTER_ACTIVE_ROUTE_CHANGED',
}

export enum ContactUsPriority {
  CRITICAL = 'Critical',
  URGENT = 'Urgent',
  HIGH = 'High',
  NORMAL = 'Normal',
}

export enum SipProviderTable {
  MIX = 'mixnetworks',
  N2P = 'net2phone',
  LEGACYN2P = 'legacy-net2phone',
}

// PostgreSQL ENUM type endpoint_type
export enum EndpointType {
  ELEVATOR = 'elevator',
  FAX = 'fax',
  FIRE_ALARM = 'fire alarm',
  MODEM = 'modem',
  SECURITY_ALARM = 'security alarm',
  TRUNK = 'trunk',
  VOICE = 'voice',
}

// Same as EndpointType but with IVR added, used for phone number type
export enum PhoneNumberContractType {
  ELEVATOR = 'elevator',
  FAX = 'fax',
  FIRE_ALARM = 'fire alarm',
  MODEM = 'modem',
  SECURITY_ALARM = 'security alarm',
  TRUNK = 'trunk',
  VOICE = 'voice',
  IVR = 'ivr',
}

// PostgreSQL ENUM type service_status_enum values
export enum SipEndpointServiceStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  TROUBLE = 'trouble',
  NONE = 'none',
}

export enum DidType {
  PERM = 'Perm DID',
  TEMP = 'Temp DID',
}

export enum SipSyncStatus {
  SYNCING = 'syncing',
  SYNCED = 'synced',
  ERROR = 'error',
}

export enum GlobalUrls {
  SIPCODE_DISPOSITION_GUIDE = 'https://marketspark.atlassian.net/wiki/spaces/DOCS/pages/2815983619/Call+Disposition+Codes',
}

export enum OrganizationAuthOptions {
  USER_CREDENTIALS = 'User Credentials',
  MICROSOFT365 = 'Microsoft 365',
  OIDC = 'OIDC',
  CUSTOM = 'Custom',
}

export enum PublicApiIdentifierOptions {
  GENERAL = 'General',
  PROVISIONER = 'Provisioner',
}

export enum SipEndpointEvent {
  CREATE_ENDPOINT = 'create sip endpoint',
  UPDATE_ENDPOINT = 'update sip endpoint',
  DELETE_ENDPOINT = 'delete sip endpoint',
}

// SQS events between cmdc-api and the sip-processor.
export enum SipEventType {
  CREATE_SITE = 'CREATE_SITE',
  CREATE_SUB = 'CREATE_SUB',
  DELETE_SUB = 'DELETE_SUB',
  DELETE_SITE = 'DELETE_SITE',
}

export enum SipSubscriptionType {
  STATUS = 'status',
  CDR = 'cdr',
}

export enum SipEventEventType {
  DOMAIN = 'domain',
  STATUS_SUBSCRIPTION = 'status_subscription',
  CDR_SUBSCRIPTION = 'cdr_subscription',
  ENDPOINT = 'endpoint',
}

export enum SipEventAction {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum SipEventStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum SipSyncState {
  IN_PROGRESS = 'in-progress',
  SYNCED = 'synced',
  ERROR = 'error',
}

export enum SimOwnership {
  MARKETSPARK = 'MarketSpark',
  CARRIER = 'Carrier',
}
